import o, { forwardRef as m } from "react";
import { ChevronRight as u } from "@olxbr/ds-icons";
import { cls as b } from "../../../helpers/cls.js";
var v = Object.defineProperty,
  d = Object.defineProperties,
  x = Object.getOwnPropertyDescriptors,
  l = Object.getOwnPropertySymbols,
  n = Object.prototype.hasOwnProperty,
  i = Object.prototype.propertyIsEnumerable,
  c = (e, r, a) => r in e ? v(e, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: a
  }) : e[r] = a,
  O = (e, r) => {
    for (var a in r || (r = {})) n.call(r, a) && c(e, a, r[a]);
    if (l) for (var a of l(r)) i.call(r, a) && c(e, a, r[a]);
    return e;
  },
  y = (e, r) => d(e, x(r)),
  N = (e, r) => {
    var a = {};
    for (var t in e) n.call(e, t) && r.indexOf(t) < 0 && (a[t] = e[t]);
    if (e != null && l) for (var t of l(e)) r.indexOf(t) < 0 && i.call(e, t) && (a[t] = e[t]);
    return a;
  };
const s = m((e, r) => {
  var a = e,
    {
      hideOnMobile: t,
      className: p
    } = a,
    f = N(a, ["hideOnMobile", "className"]);
  return o.createElement("button", y(O({
    "data-ds-component": "DS-Carousel-Button",
    className: b({
      "olx-carousel__next": !0,
      "olx-carousel__next--hide-on-mobile": t
    }, p),
    "aria-label": "Ir para o pr\xF3ximo slide",
    type: "button"
  }, f), {
    ref: r
  }), o.createElement("span", {
    className: "olx-carousel__arrow-icon"
  }, o.createElement(u, null)));
});
s.displayName = "CarouselNext";
export { s as CarouselNext };